export default "__VITE_ASSET__Csy5alRW__"